// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"118":"d1cb9a9e","212":"ea07c38e","842":"e3317608","889":"9a99fb8a"}[chunkId] + ".css";
};